// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"5c733b4d","588":"f9f33b1a","832":"5c733b4d","986":"a1bfb913"}[chunkId] + ".chunk.css";
};